import { render, staticRenderFns } from "./BusModal.vue?vue&type=template&id=35267d72&"
import script from "./BusModal.vue?vue&type=script&lang=js&"
export * from "./BusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports